import { MinusCircle as MinusCircle_kojaro } from './MinusCircle.kojaro';
import { MinusCircle as MinusCircle_phosphor } from './MinusCircle.phosphor';
import { MinusCircle as MinusCircle_zoomg } from './MinusCircle.zoomg';
import { MinusCircle as MinusCircle_zoomit } from './MinusCircle.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return MinusCircle_kojaro;

    case 'zoomg':
      return MinusCircle_zoomg;

    case 'phosphor':
      return MinusCircle_phosphor;

    default:
      return MinusCircle_zoomit;
  }
};

export const MinusCircle = IconRenderer();
